import React from "react";
import GlobalMetricCards from "../../../../global/GlobalMetricCards";

/** Office — Schedule Entry (scoped to logged-in user). */
export default function ScheduleStaffMetricCards({ loading, dashboardStats }) {
  const stats = dashboardStats || {
    today_schedules: 0,
    upcoming_schedules: 0,
    completed_schedules: 0,
    pending_schedules: 0,
  };

  const metricItems = [
    {
      key: "today_schedules",
      label: "Today's Schedules",
      value: stats.today_schedules ?? 0,
      tone: "teal",
      chartHeights: [0.38, 0.52, 0.65, 0.55, 0.7],
    },
    {
      key: "upcoming_schedules",
      label: "Upcoming Schedules",
      value: stats.upcoming_schedules ?? 0,
      tone: "slate",
      chartHeights: [0.42, 0.58, 0.48, 0.62, 0.72],
    },
    {
      key: "completed_schedules",
      label: "Completed",
      value: stats.completed_schedules ?? 0,
      tone: "mint",
      chartHeights: [0.55, 0.62, 0.58, 0.7, 0.78],
    },
    {
      key: "pending_schedules",
      label: "Pending",
      value: stats.pending_schedules ?? 0,
      tone: "teal",
      chartHeights: [0.4, 0.5, 0.55, 0.6, 0.65],
    },
  ];

  return (
    <GlobalMetricCards
      items={metricItems}
      loading={loading}
      skeletonCount={4}
      ariaLabel="Schedule summary statistics"
      gridClassName="gm-metrics-grid--quad"
    />
  );
}
